import React, { useState, useEffect } from 'react';
import { Card, Button, Modal, Alert, Form, Table } from 'react-bootstrap';
import axios from 'axios';
import PageTitle from 'components/common/PageTitle';
import Loading from 'components/common/Loading';
import Valid8CSVModal from './Valid8CSVModal';

const PAGETITLE_APP = 'Valid8';
const PAGETITLE_PAGE = 'CSVs';

const Valid8CSV = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [csvs, setCSVs] = useState([]);

  useEffect(() => {
    onPageLoad();
    const interval = setInterval(() => {
      onPageLoad(true);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const onPageLoad = async (background = false) => {
    if (!background) {
      setCSVs([]);
      setLoading(true);
    }
    try {
      const res = await axios.get('/pmladmin/valid8-csvs/data');
      setCSVs(res.data);
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  };

  return (
    <>
      <Valid8CSVModal
        show={showModal}
        setShow={setShowModal}
        reload={onPageLoad}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <PageTitle app={PAGETITLE_APP} page={PAGETITLE_PAGE} />
        <div style={{ display: 'flex', gap: 8 }}>
          <Button variant="danger" onClick={() => setShowModal(true)}>
            Upload CSV
          </Button>
        </div>
      </div>
      <div>
        {loading && <Loading />}
        {!loading &&
          csvs.length > 0 &&
          csvs.map(csv => <CSV key={csv.ID} data={csv} />)}
      </div>
    </>
  );
};

const CSV = ({ data }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const id = data.ID;

  const download = async () => {
    const url = `/pmladmin/valid8-csvs/${id}/download`;
    const response = await fetch(url);

    if (!response.body) {
      throw new Error('ReadableStream not supported in this browser');
    }

    const reader = response.body.getReader();
    const stream = new ReadableStream({
      start(controller) {
        setIsDownloading(true);
        function push() {
          reader.read().then(({ done, value }) => {
            if (done) {
              controller.close();
              setIsDownloading(false);
              return;
            }
            controller.enqueue(value);
            push();
          });
        }
        push();
      }
    });

    const blob = await new Response(stream).blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = data.OriginalFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Card className="mb-3">
      <Card.Body>
        <p>
          {data.OriginalFilename} - {data.DateStarted} -
          {data.EmailsCount == -1 && ' Uploading'}
          {data.EmailsCount !== -1 &&
            ` ${data.CompletedCount}/${data.EmailsCount}`}
        </p>
        <Button
          variant="danger"
          onClick={download}
          disabled={data.CompletedCount !== data.EmailsCount || isDownloading}
        >
          {isDownloading ? 'Downloading...' : 'Download'}
        </Button>
      </Card.Body>
    </Card>
  );
};

export default Valid8CSV;
